module.exports = __webpack_public_path__ + "static/media/delete_red.9f316c0a.svg";